var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDe({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 85.331,
    fill: "#D80027",
    width: 512,
    height: 341.337
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 85.331,
    width: 512,
    height: 113.775
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 312.882,
    fill: "#FFDA44",
    width: 512,
    height: 113.775
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDe);
export default __webpack_public_path__ + "static/media/de.b8cc981b8c5cc82c46dc00be0657ce4c.svg";
export { ForwardRef as ReactComponent };